<template>
  <NavigationHeader :title="wp.title" />
</template>

<script>
export default {
  name: 'ResourcesNcfHeader',
  inject: ['wp']
}
</script>
